var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"select-collaborators__dropdown-item",class:{
    hidden: !_vm.isVisible(_vm.query),
    active: _vm.isActive(_vm.value),
    disabled: _vm.disabled,
    hover: _vm.isHovering(_vm.value),
  }},[_c('a',{staticClass:"select-collaborators__dropdown-link",on:{"click":function($event){return _vm.select(_vm.value, _vm.disabled)},"mousemove":function($event){return _vm.hover(_vm.value, _vm.disabled)}}},[_c('div',{staticClass:"select-collaborators__initials"},[_vm._v(_vm._s(_vm.initial(_vm.name)))]),_vm._v(" "),_c('div',{staticClass:"select-collaborators__dropdown-option"},[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }